import { render } from "./DaftarView.html?vue&type=template&id=35ce640c&ts=true&external"
import script from "./DaftarView.ts?vue&type=script&lang=ts&external"
export * from "./DaftarView.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__